import { Image } from 'antd';
import HSTooltip from '../../../../assets/icons/hs-tooltip.png';

export const HSTooltipComponent = () => (
  <Image className="m10" src={HSTooltip} preview={false} width={500} alt="How to Read Weight Reading Card" />
);
